import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { putRequest } from '../../../requestUtils';
import '../ProjectDetails.scss';
import DropdownIndicator from '../../common/DropdownIndicator';
var formStep = 'admin';
var customStyles = {
  option: function option(styles, _ref) {
    var isDisabled = _ref.isDisabled;
    return _objectSpread(_objectSpread({}, styles), {}, {
      opacity: isDisabled ? 0.5 : 1,
      cursor: isDisabled ? 'not-allowed' : 'default'
    });
  }
};
var processTakeRate = function processTakeRate(takeRate) {
  if (!takeRate) return 25.0;
  return Math.round(takeRate * 10000) / 100;
};
var AdminModal = /*#__PURE__*/function (_Component) {
  function AdminModal(props) {
    var _this;
    _classCallCheck(this, AdminModal);
    _this = _callSuper(this, AdminModal, [props]);
    _this.state = {
      startDate: null,
      consultantNeedsToSignAgreement: false,
      taxType: '',
      consultantWorkingWith: '',
      internalBudgetApproval: false,
      jobTitle: '',
      takeRate: null,
      projectType: null,
      showModal: props.modalOpen
    };
    _this.handleShowModal = _this.handleShowModal.bind(_this);
    _this.handleHideModal = _this.handleHideModal.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.updateProjectDetails = _this.updateProjectDetails.bind(_this);
    return _this;
  }
  _inherits(AdminModal, _Component);
  return _createClass(AdminModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var projectResourceId = this.props.projectResourceId;
      if (!projectResourceId) return;
      this.updateProjectDetails();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.modalOpen !== prevProps.modalOpen) {
        this.setState({
          showModal: this.props.modalOpen
        });
      }
    }
  }, {
    key: "updateProjectDetails",
    value: function updateProjectDetails() {
      var _this2 = this;
      var getProjectDetails = this.props.getProjectDetails;
      getProjectDetails(formStep).then(function (response) {
        if (response.data.approximate_start_date_local) {
          _this2.setState({
            startDate: new Date("".concat(response.data.approximate_start_date_local, " 0:00"))
          });
        }
        _this2.setState({
          consultantNeedsToSignAgreement: response.data.consultant_needs_sign_agreement,
          taxType: response.data.tax_type,
          consultantWorkingWith: response.data.consultant_working_with,
          internalBudgetApproval: response.data.have_internal_budget_approval,
          jobTitle: response.data.job_title,
          takeRate: processTakeRate(response.data.clora_take_rate),
          projectType: response.data.project_type_for_select
        });
      });
    }
  }, {
    key: "handleHideModal",
    value: function handleHideModal() {
      this.setState({
        showModal: false
      });
    }
  }, {
    key: "handleShowModal",
    value: function handleShowModal() {
      this.setState({
        showModal: true
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this3 = this;
      var _this$props = this.props,
        csrfToken = _this$props.csrfToken,
        projectResourceId = _this$props.projectResourceId,
        afterSubmit = _this$props.afterSubmit;
      var _this$state = this.state,
        startDate = _this$state.startDate,
        consultantNeedsToSignAgreement = _this$state.consultantNeedsToSignAgreement,
        taxType = _this$state.taxType,
        consultantWorkingWith = _this$state.consultantWorkingWith,
        internalBudgetApproval = _this$state.internalBudgetApproval,
        jobTitle = _this$state.jobTitle,
        takeRate = _this$state.takeRate,
        projectType = _this$state.projectType;
      var params = {
        project: {
          approximate_start_date_local: startDate,
          consultant_needs_sign_agreement: consultantNeedsToSignAgreement,
          tax_type: taxType,
          consultant_working_with: consultantWorkingWith,
          have_internal_budget_approval: internalBudgetApproval,
          project_type: projectType.value,
          clora_take_rate: takeRate,
          job_title: jobTitle
        }
      };
      putRequest("/projects/".concat(projectResourceId), params, csrfToken).then(function () {
        _this3.handleHideModal();
        afterSubmit();
      })["catch"](function (error) {
        _this3.setState({
          errors: error.name
        });
        return null;
      });
    }
  }, {
    key: "renderProjectType",
    value: function renderProjectType() {
      var _this4 = this;
      var projectTypes = this.props.projectTypes;
      return /*#__PURE__*/React.createElement("div", {
        className: "admin-project-type mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 demibold py-3"
      }, "Project type"), /*#__PURE__*/React.createElement(Select, {
        components: {
          DropdownIndicator: DropdownIndicator,
          IndicatorSeparator: function IndicatorSeparator() {
            return null;
          }
        },
        classNamePrefix: "clora-multiselect",
        closeMenuOnSelect: true,
        value: this.state.projectType,
        className: "project-type-select",
        id: "project-type-select",
        onChange: function onChange(option) {
          return _this4.setState({
            projectType: option
          });
        },
        isDisabled: false,
        placeholder: "Select the project type",
        options: projectTypes,
        isOptionDisabled: function isOptionDisabled(option) {
          return option.label.toLowerCase() === 'request';
        },
        styles: customStyles
      }));
    }
  }, {
    key: "renderTakeRate",
    value: function renderTakeRate() {
      var _this5 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 demibold mt-4 mb-2"
      }, "Clora take rate"), /*#__PURE__*/React.createElement("input", {
        name: "clora-take-rate",
        className: "form-control rate-form",
        value: this.state.takeRate || '',
        onChange: function onChange(e) {
          return _this5.setState({
            takeRate: e.target.value
          });
        }
      }), "\xA0\xA0%");
    }
  }, {
    key: "renderStartDate",
    value: function renderStartDate() {
      var _this6 = this;
      var today = new Date();
      var projectResourceId = this.props.projectResourceId;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold mb-2"
      }, "Project start date"), /*#__PURE__*/React.createElement("div", {
        className: "start-date-datepicker-container"
      }, /*#__PURE__*/React.createElement("label", {
        className: "g-row--always",
        htmlFor: "start-date-".concat(projectResourceId)
      }, /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.startDate,
        onChange: function onChange(newDate) {
          return _this6.setState({
            startDate: newDate
          });
        },
        dateFormat: "MM/dd/yyyy",
        className: "start-date-datepicker",
        id: "start-date-".concat(projectResourceId),
        minDate: today,
        openToDate: today
      }), /*#__PURE__*/React.createElement("span", {
        className: "input-group-addon"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-calendar adjust-center"
      })))));
    }
  }, {
    key: "renderRadioChoice",
    value: function renderRadioChoice(attribute, labelText) {
      var _this7 = this;
      var id = "".concat(attribute, "-").concat(labelText);
      var choice;
      if (labelText === 'Yes') {
        choice = true;
      } else if (labelText === 'No') {
        choice = false;
      } else {
        choice = labelText;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "".concat(id, "-choice choice")
      }, /*#__PURE__*/React.createElement("input", {
        type: "radio",
        id: id,
        name: id,
        onChange: function onChange() {
          return _this7.setState(_defineProperty({}, attribute, choice));
        },
        checked: this.state[attribute] === choice
      }), /*#__PURE__*/React.createElement("label", {
        htmlFor: id
      }, "\xA0", labelText));
    }
  }, {
    key: "renderMultipleChoice",
    value: function renderMultipleChoice() {
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold py-3"
      }, "Non-compete agreement required?"), this.renderRadioChoice('consultantNeedsToSignAgreement', 'Yes'), this.renderRadioChoice('consultantNeedsToSignAgreement', 'No'), /*#__PURE__*/React.createElement("div", {
        className: "demibold py-3 mt-2"
      }, "Tax filing"), this.renderRadioChoice('taxType', '1099'), this.renderRadioChoice('taxType', 'W-2'), /*#__PURE__*/React.createElement("div", {
        className: "demibold py-3 mt-2"
      }, "Internal budget approved?"), this.renderRadioChoice('internalBudgetApproval', 'Yes'), this.renderRadioChoice('internalBudgetApproval', 'No'));
    }
  }, {
    key: "renderTextAreas",
    value: function renderTextAreas() {
      var _this8 = this;
      return /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold py-3"
      }, "Who will the candidate be working with?"), /*#__PURE__*/React.createElement("textarea", {
        name: "consultant-working-with",
        className: "scope-form form-control fs-hide null",
        value: this.state.consultantWorkingWith || '',
        onChange: function onChange(e) {
          return _this8.setState({
            consultantWorkingWith: e.target.value
          });
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/React.createElement("div", {
        className: "demibold py-3"
      }, "Job title"), /*#__PURE__*/React.createElement("textarea", {
        name: "job-title",
        className: "scope-form form-control fs-hide null",
        value: this.state.jobTitle || '',
        onChange: function onChange(e) {
          return _this8.setState({
            jobTitle: e.target.value
          });
        }
      })));
    }
  }, {
    key: "renderButtons",
    value: function renderButtons() {
      return /*#__PURE__*/React.createElement("div", {
        className: "buttons-container g-row mt-4"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-6"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-3"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: this.handleHideModal
      }, "Cancel")), /*#__PURE__*/React.createElement("div", {
        className: "g-column g-flex-3"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSubmit
      }, "Save")));
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      var errors = this.state.errors;
      return errors && /*#__PURE__*/React.createElement("div", {
        id: "error_explanation"
      }, /*#__PURE__*/React.createElement("h3", null, "Errors prohibited this project from being saved:"), /*#__PURE__*/React.createElement("ul", null, errors.map(function (e) {
        return /*#__PURE__*/React.createElement("li", null, e);
      })));
    }
  }, {
    key: "renderModalLink",
    value: function renderModalLink() {
      return /*#__PURE__*/React.createElement("a", {
        role: "link",
        tabIndex: 0,
        className: "project-edit-link ml",
        onClick: this.handleShowModal
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-edit"
      }), "\xA0", this.props.formType === 'modal-link' ? 'Edit' : '');
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-admin-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "admin-entry-container"
      }, this.renderProjectType(), this.renderTakeRate(), this.renderStartDate(), this.renderMultipleChoice(), this.renderTextAreas(), this.renderButtons()));
    }
  }, {
    key: "renderModal",
    value: function renderModal() {
      return /*#__PURE__*/React.createElement(Modal, {
        show: this.state.showModal,
        onHide: this.handleHideModal,
        dialogClassName: "admin-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true,
        className: "admin-modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "ms-5 mt-4 mb-3"
      }, "Admin")), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "admin-modal-body"
      }, this.renderContent()));
    }
  }, {
    key: "render",
    value: function render() {
      if (this.props.formType === 'page') {
        return this.renderContent();
      }
      if (this.props.formType === 'modal-only') {
        return this.renderModal();
      }
      return /*#__PURE__*/React.createElement("span", null, this.renderModalLink(), this.renderModal());
    }
  }]);
}(Component);
AdminModal.propTypes = {
  formType: PropTypes.string,
  // one of 'page', 'modal-link', 'modal-icon'
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  afterSubmit: PropTypes.func,
  getProjectDetails: PropTypes.func.isRequired,
  projectTypes: PropTypes.arrayOf(PropTypes.shape({})),
  modalOpen: PropTypes.bool
};
AdminModal.defaultProps = {
  formType: 'page',
  projectResourceId: null,
  afterSubmit: function afterSubmit() {},
  projectTypes: [],
  modalOpen: false
};
export default AdminModal;